module.exports = __webpack_public_path__ + "static/media/menu-black.b5098bdc.png";